import React, { type FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveGeneratedImage } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { useAiPhotoGenerationAnalyticData } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.hooks';
import { openAiPhotoGenerationResetModal } from 'reactApp/ui/AiPhotoGeneration/Modals/ResetGeneration/AiPhotoGenerationResetModal.helpers';
import { AiPhotoGenerationButtonRefresh } from 'reactApp/ui/AiPhotoGeneration/ToolbarComplete/ButtonRefresh/AiPhotoGenerationButtonRefresh';
import { AiPhotoGenerationButtonSave } from 'reactApp/ui/AiPhotoGeneration/ToolbarComplete/ButtonSave/AiPhotoGenerationButtonSave';
import { AiPhotoGenerationRatingBlock } from 'reactApp/ui/AiPhotoGeneration/ToolbarComplete/Rating/AiPhotoGenerationRatingBlock';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationToolbarComplete.css';

export const AiPhotoGenerationToolbarComplete: FC = memo(function AiPhotoGenerationToolbarComplete() {
    const dispatch = useDispatch();
    const analyticData = useAiPhotoGenerationAnalyticData();

    const handleReset = useCallback(() => {
        openAiPhotoGenerationResetModal();

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'refresh-btn-click',
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user']],
        });
    }, [analyticData]);

    const handleSave = useCallback(() => {
        dispatch(saveGeneratedImage({}));

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'save-btn-click',
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user']],
        });
    }, [analyticData, dispatch]);

    return (
        <div className={styles.root} data-test-id="ai-photo-generation-toolbar-complete">
            <div className={styles.container}>
                <AiPhotoGenerationRatingBlock />
                <AiPhotoGenerationButtonRefresh onClick={handleReset} />
                <AiPhotoGenerationButtonSave onClick={handleSave} />
            </div>
        </div>
    );
});

AiPhotoGenerationToolbarComplete.displayName = 'AiPhotoGenerationToolbarComplete';
